import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.index-of.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { startTrackingWebVitals, startTrackingINP, startTrackingLongAnimationFrames, startTrackingLongTasks, startTrackingInteractions, addHistoryInstrumentationHandler, registerInpInteractionListener, addPerformanceEntries } from '@sentry-internal/browser-utils';
import { TRACING_DEFAULTS, registerSpanErrorInstrumentation, GLOBAL_OBJ, getClient, propagationContextFromHeaders, getCurrentScope, spanToJSON, getRootSpan, spanIsSampled, getDynamicSamplingContextFromSpan, browserPerformanceTimeOrigin, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, getActiveSpan, getIsolationScope, generateTraceId, getDomElement, startIdleSpan, logger, SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON } from '@sentry/core';
import { DEBUG_BUILD } from '../debug-build.js';
import { WINDOW } from '../helpers.js';
import { registerBackgroundTabDetection } from './backgroundtab.js';
import { defaultRequestInstrumentationOptions, instrumentOutgoingRequests } from './request.js';

/* eslint-disable max-lines */

var BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';
var DEFAULT_BROWSER_TRACING_OPTIONS = _objectSpread(_objectSpread({}, TRACING_DEFAULTS), {}, {
  instrumentNavigation: true,
  instrumentPageLoad: true,
  markBackgroundSpan: true,
  enableLongTask: true,
  enableLongAnimationFrame: true,
  enableInp: true,
  _experiments: {}
}, defaultRequestInstrumentationOptions);

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */
var browserTracingIntegration = function browserTracingIntegration() {
  var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  registerSpanErrorInstrumentation();
  var _DEFAULT_BROWSER_TRAC = _objectSpread(_objectSpread({}, DEFAULT_BROWSER_TRACING_OPTIONS), _options),
    enableInp = _DEFAULT_BROWSER_TRAC.enableInp,
    enableLongTask = _DEFAULT_BROWSER_TRAC.enableLongTask,
    enableLongAnimationFrame = _DEFAULT_BROWSER_TRAC.enableLongAnimationFrame,
    _DEFAULT_BROWSER_TRAC2 = _DEFAULT_BROWSER_TRAC._experiments,
    enableInteractions = _DEFAULT_BROWSER_TRAC2.enableInteractions,
    enableStandaloneClsSpans = _DEFAULT_BROWSER_TRAC2.enableStandaloneClsSpans,
    beforeStartSpan = _DEFAULT_BROWSER_TRAC.beforeStartSpan,
    idleTimeout = _DEFAULT_BROWSER_TRAC.idleTimeout,
    finalTimeout = _DEFAULT_BROWSER_TRAC.finalTimeout,
    childSpanTimeout = _DEFAULT_BROWSER_TRAC.childSpanTimeout,
    markBackgroundSpan = _DEFAULT_BROWSER_TRAC.markBackgroundSpan,
    traceFetch = _DEFAULT_BROWSER_TRAC.traceFetch,
    traceXHR = _DEFAULT_BROWSER_TRAC.traceXHR,
    trackFetchStreamPerformance = _DEFAULT_BROWSER_TRAC.trackFetchStreamPerformance,
    shouldCreateSpanForRequest = _DEFAULT_BROWSER_TRAC.shouldCreateSpanForRequest,
    enableHTTPTimings = _DEFAULT_BROWSER_TRAC.enableHTTPTimings,
    instrumentPageLoad = _DEFAULT_BROWSER_TRAC.instrumentPageLoad,
    instrumentNavigation = _DEFAULT_BROWSER_TRAC.instrumentNavigation;
  var _collectWebVitals = startTrackingWebVitals({
    recordClsStandaloneSpans: enableStandaloneClsSpans || false
  });
  if (enableInp) {
    startTrackingINP();
  }
  if (enableLongAnimationFrame && GLOBAL_OBJ.PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('long-animation-frame')) {
    startTrackingLongAnimationFrames();
  } else if (enableLongTask) {
    startTrackingLongTasks();
  }
  if (enableInteractions) {
    startTrackingInteractions();
  }
  var latestRoute = {
    name: undefined,
    source: undefined
  };

  /** Create routing idle transaction. */
  function _createRouteSpan(client, startSpanOptions) {
    var isPageloadTransaction = startSpanOptions.op === 'pageload';
    var finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
    var attributes = finalStartSpanOptions.attributes || {};

    // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
    // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
    if (startSpanOptions.name !== finalStartSpanOptions.name) {
      attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'custom';
      finalStartSpanOptions.attributes = attributes;
    }
    latestRoute.name = finalStartSpanOptions.name;
    latestRoute.source = attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    var idleSpan = startIdleSpan(finalStartSpanOptions, {
      idleTimeout: idleTimeout,
      finalTimeout: finalTimeout,
      childSpanTimeout: childSpanTimeout,
      // should wait for finish signal if it's a pageload transaction
      disableAutoFinish: isPageloadTransaction,
      beforeSpanEnd: function beforeSpanEnd(span) {
        _collectWebVitals();
        addPerformanceEntries(span, {
          recordClsOnPageloadSpan: !enableStandaloneClsSpans
        });
      }
    });
    function emitFinish() {
      if (['interactive', 'complete'].includes(WINDOW.document.readyState)) {
        client.emit('idleSpanEnableAutoFinish', idleSpan);
      }
    }
    if (isPageloadTransaction && WINDOW.document) {
      WINDOW.document.addEventListener('readystatechange', function () {
        emitFinish();
      });
      emitFinish();
    }
    return idleSpan;
  }
  return {
    name: BROWSER_TRACING_INTEGRATION_ID,
    afterAllSetup: function afterAllSetup(client) {
      var activeSpan;
      var startingUrl = WINDOW.location && WINDOW.location.href;
      function maybeEndActiveSpan() {
        if (activeSpan && !spanToJSON(activeSpan).timestamp) {
          DEBUG_BUILD && logger.log("[Tracing] Finishing current active span with op: ".concat(spanToJSON(activeSpan).op));
          // If there's an open active span, we need to finish it before creating an new one.
          activeSpan.end();
        }
      }
      client.on('startNavigationSpan', function (startSpanOptions) {
        if (getClient() !== client) {
          return;
        }
        maybeEndActiveSpan();
        activeSpan = _createRouteSpan(client, _objectSpread({
          op: 'navigation'
        }, startSpanOptions));
      });
      client.on('startPageLoadSpan', function (startSpanOptions) {
        var traceOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (getClient() !== client) {
          return;
        }
        maybeEndActiveSpan();
        var sentryTrace = traceOptions.sentryTrace || getMetaContent('sentry-trace');
        var baggage = traceOptions.baggage || getMetaContent('baggage');
        var propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
        getCurrentScope().setPropagationContext(propagationContext);
        activeSpan = _createRouteSpan(client, _objectSpread({
          op: 'pageload'
        }, startSpanOptions));
      });

      // A trace should to stay the consistent over the entire time span of one route.
      // Therefore, when the initial pageload or navigation root span ends, we update the
      // scope's propagation context to keep span-specific attributes like the `sampled` decision and
      // the dynamic sampling context valid, even after the root span has ended.
      // This ensures that the trace data is consistent for the entire duration of the route.
      client.on('spanEnd', function (span) {
        var op = spanToJSON(span).op;
        if (span !== getRootSpan(span) || op !== 'navigation' && op !== 'pageload') {
          return;
        }
        var scope = getCurrentScope();
        var oldPropagationContext = scope.getPropagationContext();
        scope.setPropagationContext(_objectSpread(_objectSpread({}, oldPropagationContext), {}, {
          sampled: oldPropagationContext.sampled !== undefined ? oldPropagationContext.sampled : spanIsSampled(span),
          dsc: oldPropagationContext.dsc || getDynamicSamplingContextFromSpan(span)
        }));
      });
      if (WINDOW.location) {
        if (instrumentPageLoad) {
          var _attributes;
          startBrowserTracingPageLoadSpan(client, {
            name: WINDOW.location.pathname,
            // pageload should always start at timeOrigin (and needs to be in s, not ms)
            startTime: browserPerformanceTimeOrigin ? browserPerformanceTimeOrigin / 1000 : undefined,
            attributes: (_attributes = {}, _defineProperty(_attributes, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, 'url'), _defineProperty(_attributes, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.pageload.browser'), _attributes)
          });
        }
        if (instrumentNavigation) {
          addHistoryInstrumentationHandler(function (_ref) {
            var to = _ref.to,
              from = _ref.from;
            /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */
            if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
              startingUrl = undefined;
              return;
            }
            if (from !== to) {
              var _attributes2;
              startingUrl = undefined;
              startBrowserTracingNavigationSpan(client, {
                name: WINDOW.location.pathname,
                attributes: (_attributes2 = {}, _defineProperty(_attributes2, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, 'url'), _defineProperty(_attributes2, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.navigation.browser'), _attributes2)
              });
            }
          });
        }
      }
      if (markBackgroundSpan) {
        registerBackgroundTabDetection();
      }
      if (enableInteractions) {
        registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
      }
      if (enableInp) {
        registerInpInteractionListener();
      }
      instrumentOutgoingRequests(client, {
        traceFetch: traceFetch,
        traceXHR: traceXHR,
        trackFetchStreamPerformance: trackFetchStreamPerformance,
        tracePropagationTargets: client.getOptions().tracePropagationTargets,
        shouldCreateSpanForRequest: shouldCreateSpanForRequest,
        enableHTTPTimings: enableHTTPTimings
      });
    }
  };
};

/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */
function startBrowserTracingPageLoadSpan(client, spanOptions, traceOptions) {
  client.emit('startPageLoadSpan', spanOptions, traceOptions);
  getCurrentScope().setTransactionName(spanOptions.name);
  var span = getActiveSpan();
  var op = span && spanToJSON(span).op;
  return op === 'pageload' ? span : undefined;
}

/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */
function startBrowserTracingNavigationSpan(client, spanOptions) {
  getIsolationScope().setPropagationContext({
    traceId: generateTraceId()
  });
  getCurrentScope().setPropagationContext({
    traceId: generateTraceId()
  });
  client.emit('startNavigationSpan', spanOptions);
  getCurrentScope().setTransactionName(spanOptions.name);
  var span = getActiveSpan();
  var op = span && spanToJSON(span).op;
  return op === 'navigation' ? span : undefined;
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  // eslint-disable-next-line deprecation/deprecation
  var metaTag = getDomElement("meta[name=".concat(metaName, "]"));
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : undefined;
}

/** Start listener for interaction transactions */
function registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
  var inflightInteractionSpan;
  var registerInteractionTransaction = function registerInteractionTransaction() {
    var op = 'ui.action.click';
    var activeSpan = getActiveSpan();
    var rootSpan = activeSpan && getRootSpan(activeSpan);
    if (rootSpan) {
      var currentRootSpanOp = spanToJSON(rootSpan).op;
      if (['navigation', 'pageload'].includes(currentRootSpanOp)) {
        DEBUG_BUILD && logger.warn("[Tracing] Did not create ".concat(op, " span because a pageload or navigation span is in progress."));
        return undefined;
      }
    }
    if (inflightInteractionSpan) {
      inflightInteractionSpan.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON, 'interactionInterrupted');
      inflightInteractionSpan.end();
      inflightInteractionSpan = undefined;
    }
    if (!latestRoute.name) {
      DEBUG_BUILD && logger.warn("[Tracing] Did not create ".concat(op, " transaction because _latestRouteName is missing."));
      return undefined;
    }
    inflightInteractionSpan = startIdleSpan({
      name: latestRoute.name,
      op: op,
      attributes: _defineProperty({}, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, latestRoute.source || 'url')
    }, {
      idleTimeout: idleTimeout,
      finalTimeout: finalTimeout,
      childSpanTimeout: childSpanTimeout
    });
  };
  if (WINDOW.document) {
    addEventListener('click', registerInteractionTransaction, {
      once: false,
      capture: true
    });
  }
}
export { BROWSER_TRACING_INTEGRATION_ID, browserTracingIntegration, getMetaContent, startBrowserTracingNavigationSpan, startBrowserTracingPageLoadSpan };